import React, { useEffect, useState } from "react";

// Components
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import SingleImageUploader from "~/common/components/ImageUploader/SingleImageUploader";
import { UPLOAD_TYPE } from "~/common/constants/upload";

//Assets
import "~/assets/sass/pages/mypage/admin/business.scss";
import "~/assets/sass/pages/mypage/admin/business/uncertified.scss";
import "~/assets/sass/pages/mypage/admin/business/certified.scss";
import "~/assets/sass/pages/mypage/admin/business/processing.scss";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useTranslation } from "react-i18next";

const Uncertified = ({ setStep, edit, setCertImg }) => {
	const { t } = useTranslation();
	// const businessRequest = useRequest("post", "/vc/admin/business");
	const [uploadedImg, setUploadedImg] = useState("");

	const [uploaderConstant] = useState(UPLOAD_TYPE.COMPANY_BUSINESS);
	const [warningModal, setWarningModal] = useState(false);
	const [successModal, setSuccessModal] = useState(false);



	useEffect(() => {
		(uploadedImg && setCertImg) && setCertImg(uploadedImg)
	}, [uploadedImg])



	return (
		<>
			<div className="c__card uncertified">
				<div className="card-top">
					<dl className="content">
						<dt>{t("pages.myPage.admin.BusinessPage.Uncertified.dt")}</dt>
						<dd className="pre-wrap">
							{t("pages.myPage.admin.BusinessPage.Uncertified.dd")}
						</dd>
					</dl>
					{edit && <SingleImageUploader
						uploaderConstant={uploaderConstant}
						width={168}
						height={200}
						img={uploadedImg}
						setImg={setUploadedImg}
					/>}
				</div>
				{/* <div className="card-bottom">
					{uploadedImg === "" ? (
						// 사업자등록증 미제출시
						<button
							type="button"
							className="btn__solid"
							color="primary"
							onClick={() => setWarningModal(true)}
						>
							{t("pages.myPage.admin.BusinessPage.Uncertified.btn-submit")}
						</button>
					) : (
						// 사업자등록증 제출시
						<button
							type="button"
							className="btn__solid"
							color="primary"
							onClick={() => setSuccessModal(true)}
						>
							{t("pages.myPage.admin.BusinessPage.Uncertified.btn-submit")}
						</button>
					)}
				</div> */}
			</div>
			{/* <AlertTemplate
				alertModalState={warningModal}
				setAlertModalToggle={setWarningModal}
				alertType={"warning"}
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.myPage.admin.BusinessPage.Uncertified.modal-text1")}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setWarningModal(false)}
					>
						{t("common.commonWord.button.check")}
					</button>
				</div>
			</AlertTemplate> */}

			{/*사업자등록증 제출시 alertModal*/}
			{/* <AlertTemplate alertModalState={successModal} setAlertModalToggle={setSuccessModal}>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.myPage.admin.BusinessPage.Uncertified.modal-text2")}
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={handleImgSubmit}>
						{t("common.commonWord.button.check")}
					</button>
				</div>
			</AlertTemplate> */}
		</>
	);
};

export default Uncertified;
